class ServicesUtils {
	static getAntirreflexoPreferido(servicos) {
		if (!Array.isArray(servicos) || servicos.length === 0) return null;

		const antirreflexos = servicos.filter(s => s?.tipo === "ANTIRREFLEXO");
		if (antirreflexos.length === 0) return null;

		return antirreflexos.reduce((atual, candidato) => {
			const refAtual = ServicesUtils.parseCodigoRef(atual?.codigoRef);
			const refCandidato = ServicesUtils.parseCodigoRef(candidato?.codigoRef);
			return refCandidato > refAtual ? candidato : atual;
		});
	}

	static parseCodigoRef(codigoRef) {
		if (codigoRef === null || codigoRef === undefined || codigoRef === "") return Number.NEGATIVE_INFINITY;
		const parsed = parseInt(codigoRef, 10);
		return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
	}
}

export default ServicesUtils;
